// @flow

import React, { type Node } from 'react';
import { Tooltip } from './tooltip';

import {
  SideDisplayValueItem,
  SideDisplayValueItemTitle,
  SideDisplayValueItemValue,
} from './../side-display-values';

export function DisplayChileanRoundingDisclaimer(): Node {

  return (
    <SideDisplayValueItem data-testid="display_chilean_rounding_disclaimer">
      <SideDisplayValueItemTitle>
        Redondeo <Tooltip />
      </SideDisplayValueItemTitle>
      <SideDisplayValueItemValue>
        $ 5.00
      </SideDisplayValueItemValue>
    </SideDisplayValueItem>
  );
}
